// "Subscribers pay $X or less" (snippets/subscriber-price.liquid): follows the price it sits above and recomputes
// whenever that price changes (set page box/card toggles, gift path prices, live jar totals). Tiers come from
// data-tiers ("5900:6,8900:9,11900:12" = minimum cents : percent off).
(() => {
  if (window.WZ_subPrice) return;
  window.WZ_subPrice = true;
  const parse = (text) => {
    const m = String(text || '').replace(/,/g, '').match(/(\d+)(?:\.(\d{1,2}))?/);
    if (!m) return null;
    return Number(m[1]) * 100 + Number((m[2] || '0').padEnd(2, '0'));
  };
  const fmt = (cents, cur) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur || 'USD' }).format(cents / 100);
  const show = (el, on) => { if (el && el.hidden === on) el.hidden = !on; };

  function update(box) {
    const target = box.dataset.subFor ? document.querySelector(box.dataset.subFor) : box.nextElementSibling;
    if (!target) return;
    const cents = parse(target.innerText || target.textContent);
    const tiers = (box.dataset.tiers || '').split(',').filter(Boolean).map((t) => t.split(':').map(Number));
    let pct = 0;
    if (cents != null) tiers.forEach(([min, p]) => { if (cents >= min && p > pct) pct = p; });
    const line = box.querySelector('[data-sub-line]');
    const note = box.querySelector('[data-sub-note]');
    if (pct > 0) {
      const amount = fmt(cents - Math.round((cents * pct) / 100), box.dataset.currency);
      const out = box.querySelector('[data-sub-amt]');
      if (out && out.textContent !== amount) out.textContent = amount;
    }
    show(line, pct > 0);
    show(note, pct === 0);
    const anything = pct > 0 || !!note;
    if (box.hasAttribute('data-sub-reserve')) {
      const vis = anything ? '' : 'hidden';
      if (box.style.visibility !== vis) box.style.visibility = vis;
      show(box, true);
    } else {
      show(box, anything);
    }
  }

  const all = () => document.querySelectorAll('[data-sub-price]').forEach(update);
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; all(); });
  };
  new MutationObserver((records) => {
    // Ignore our own edits inside the subscriber lines.
    if (records.every((r) => r.target.closest?.('[data-sub-price]') || r.target.parentElement?.closest('[data-sub-price]'))) return;
    queue();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-pressed', 'aria-checked'] });
  all();
})();
